<template>
    <uploads-store
        v-model="uploads"
        ref="uploads"
        :url="$laroute.route('api.uploads.store')"
        :max-files="1"
        :max-size="20"
        :disabled="disabled"
        @error="error = arguments[0]"
        v-slot="{
            isLoading: is_loading,
            open
        }"
    >
        <button
            :class="{
                'is-invalid' : $validator.has(validatorName, sid),
                'is-disabled': disabled
            }"
            class="input text-left pl-12 leading-none cursor-pointer"
            @click.prevent="open"
        >
            <div class="absolute left-0 inset-y-0 flex items-center pl-4 pointer-events-none">
                <base-svg
                    :name="is_loading ? 'icon-loading' : 'icon-cloud-upload'"
                    :key="is_loading ? 'icon-loading' : 'icon-cloud-upload'"
                    class="w-6 h-6"
                />
            </div>

            <div class="my-px overflow-hidden truncate">
                <template v-if="upload">
                    {{ upload.name }}
                </template>
                <span
                    v-else
                    class="opacity-50"
                >
                    Select a file...
                </span>
            </div>
        </button>
    </uploads-store>
</template>

<script>
    import _ from 'lodash'
    import UploadsStore from './uploads-store'

    export default {
        components: {
            UploadsStore
        },
        props: {
            value: {
                validator: value => typeof value === 'object' || value === null || value === undefined,
                required: true
            },
            sid: {
                type: String,
                required: true
            },
            name: {
                type: String,
                required: true
            },
            validatorName: {
                type: String,
                required: false,
                default () {
                    return this.name.replace('[', '.').replace(']', '')
                }
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                uploads: []
            }
        },
        computed: {
            upload () {
                return _.chain(this.uploads)
                    .filter({ status: 'success' })
                    .map(file => {
                        return JSON.parse(file.xhr.response).data
                    })
                    .head()
                    .value()
            }
        },
        watch: {
            upload () {
                this.$emit('input', this.upload)
            }
        }
    }
</script>
